export default "__VITE_ASSET__BUSNnG6G__"